import {
  executeProtocol,
  executeProtocolOutApp,
  redirectUrlByServer,
  isInHeybox,
} from '_lib/utils';

//id: 获取link_id的唯一方式
export function openWindow(page, query = {}) {
  let queryString = '';

  if (query) {
    queryString = Object.keys(query)
      .filter((key) => query[key] !== undefined)
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`,
      )
      .join('&');
  }
  const url = redirectUrlByServer(`${page}?${queryString}`);

  let title = '小黑盒×TGA2024', desc = '参与TGA投票讨论赢超多好礼！', icon = 'https://imgheybox.max-c.com/oa/2024/11/18/dcc01d7568ba4b837d8ea25e60d0c1fc.png'
  switch(page) {
    case '/activity/tga_2024/home':
      title = '小黑盒TGA投票通道现已开启'
      desc = '投票同步计入最终TGA票选结果，还有机会抽取年度游戏Cdkey'
      break
    case '/activity/tga_2024/ceremony':
      title = 'TGA2024颁奖典礼正在中文直播中！'
      desc = '来小黑盒一起见证2024年度游戏的诞生！!'
      icon = 'https://imgheybox.max-c.com/oa/2024/12/12/6689fb04b1166059fad19a602856e229.jpeg'
      break
  }

  let protocol = {
    protocol_type: 'openWindow',
    status_bar: {
      style: 'light',
    },
    navigation_bar: {
      title: '',
      right_icon: {
        enabled: 'true',
        protocol: {
          protocol_type: 'share',
          title,
          desc,
          share_url: `${url}&is_share=1`,
          img_url: icon,
          act_id: '_heyboxtga',
          src: 'tga2024_url',
        },
      },
    },
    full_screen: true,
    miniprogram: false,
    webview: {
      url,
      pull: false,
      refresh: false,
      bg: '000000',
    },
  };
  isInHeybox() ? executeProtocol(protocol) : executeProtocolOutApp(protocol);
}
